module.exports = __webpack_public_path__ + "static/diaconia_737x621-71e2cc173f78887a4acfb186eb81820c.png";